import { React } from 'react';

import { Route, Routes } from 'react-router-dom';

import ProtectedRoute from '../components/protectedRoutes';
import CrmInfluencerDashboard from '../pages/parceiro/crmInfluencerDashboard';

const RouteParceiro = () => {
    return (
        <Routes>
            <Route element={<ProtectedRoute role={'Influencer'}/>}>
                <Route path='dashboard' element={<CrmInfluencerDashboard/>}/>
            </Route>
        </Routes>
    );
};

export default RouteParceiro;
